import { Controller } from "@hotwired/stimulus"

// US phone formatting only. Strips non-digits, formats as (XXX) XXX-XXXX.
// For international numbers, swap in a library like Cleave.js + libphonenumber.
export default class extends Controller {
  format(event) {
    // An 11-digit number starting with 1 carries the US country code
    // (pasted or autofilled "+1 (801) 555-1234"). Drop it, or the slice to 10
    // would keep the 1 and lose the last digit. The server strips it the same way.
    let digits = event.target.value.replace(/\D/g, "")
    if (digits.length === 11 && digits.startsWith("1")) digits = digits.slice(1)
    digits = digits.slice(0, 10)
    let formatted = digits

    if (digits.length >= 7) {
      formatted = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
    } else if (digits.length >= 4) {
      formatted = `(${digits.slice(0, 3)}) ${digits.slice(3)}`
    } else if (digits.length >= 1) {
      formatted = `(${digits.slice(0, 3)}`
    }

    event.target.value = formatted
  }
}
